import { LanguageType } from '@/custom-types';
import { IncidentCategoryOption } from '@/graphql/generated';

export const incidentCategoryMapper = (type: IncidentCategoryOption, language: LanguageType) => {
  const texts = {
    en: {
      CLEANING: 'Cleaning',
      CONSTRUCTION: 'Construction',
      ELECTRICITY: 'Electricity',
      GARDERING: 'Gardering',
      GAS: 'Gas',
      INTERNET: 'Internet',
      LOCK: 'Lock',
      METAL_CARPENTRY: 'Metal Carpentry',
      OTHER: 'Other',
      WATER: 'Water',
      WOOD_CARPENTRY: 'Wood Carpentry',
      CHECKOUT: 'Checkout'
    },
    es: {
      CLEANING: 'Limpieza',
      CONSTRUCTION: 'Construcción',
      ELECTRICITY: 'Electricidad',
      GARDERING: 'Jardinería',
      GAS: 'Gas',
      INTERNET: 'Internet',
      LOCK: 'Cerrajería',
      METAL_CARPENTRY: 'Carpintería metálica',
      OTHER: 'Otro',
      WATER: 'Agua',
      WOOD_CARPENTRY: 'Carpintería de madera',
      CHECKOUT: 'Checkout'
    }
  }

  return texts[language][type]
}
